export enum FilterTypeEnum {
  ATTRIBUTE = 'ATTRIBUTE',
  SPATIAL = 'SPATIAL',
}
